import * as v from "valibot";

export const fromPageParam = v.optional(v.picklist(["workflows"]));

export const tabParam = v.optional(v.string());

export const detailSearchParams = v.object({
  from: fromPageParam,
  tab: tabParam,
});

const NOTES_TAB = "notes";

// A note email links to a detail page with ?tab=notes, so the page opens on its notes.
export const initialDetailTab = (
  tab: string | undefined,
  fallback: string,
): string => (tab === NOTES_TAB ? NOTES_TAB : fallback);
